export default "__VITE_ASSET__5zJ$DNIS__"